import AnswerOptionList, { AnswerOptionListProps } from './AnswerOptionList';

export type { AnswerOptionListProps };
export default AnswerOptionList;
